exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-capture-modal > .capture-modal {\n  padding-bottom: 60px;\n}\n", ""]);

// exports
